import { fetchDetailData } from '../api';
import { ISSUE_DETAIL_URL } from '../const';
import { useDataQuery } from '@packages/dataQuery';
import { IssueDetailResponseData } from '../types';
import { setDocumentTitle } from '../../../page/utils';

const DEFAULT_DATA: IssueDetailResponseData = {
	address: {
		organizationName: null,
		contactAddressStreet: null,
		contactAddressNumber: null,
		contactAddressUnit: null,
		contactAddressPostalCode: null,
		contactAddressCity: null,
		postAddressStreet: null,
		postAddressNumber: null,
		postAddressUnit: null,
		postAddressPostalCode: null,
		postAddressCity: null,
		organizationEmail: null,
	},
	recaptchaPublicKey: '',
	form: {
		values: {},
	},
	page: { title: '' },
};

export function useIssueDetailDataQuery() {
	const dataQuery = useDataQuery([ISSUE_DETAIL_URL], () => fetchDetailData(), {
		onSuccess: (data) => {
			setDocumentTitle(data.page.title);
		},
	});

	return {
		...dataQuery,
		data: dataQuery.data || DEFAULT_DATA,
	};
}
